import styled from 'styled-components';
import { ListItem, RowBox } from 'styles';

export const Main = styled.main`
  padding-top: 91px;

  @media ${({ theme }) => theme.device.mobile} {
    padding-top: 102px;
  }
`;

export const VisualBox = styled(RowBox)`
  gap: 46px;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.tablet} {
    flex-direction: column-reverse;
  }

  @media ${({ theme }) => theme.device.mobile} {
    align-items: center;
    text-align: center;
    gap: 16px;
  }
`;

export const GradientItem = styled(ListItem)`
  background-color: ${({ theme }) => theme.colors.gray50};
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  border-radius: 8px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1.5px;
    bottom: -1px;
    background-image: ${({ $checked }) => ($checked ? 'linear-gradient(to right, #2fffbd, #96bce0)' : 'none')};
    background-origin: border-box;
    background-clip: padding-box, border-box;
    border-radius: 8px;
    z-index: -1;
  }
`;